export interface DateRange {
  from: Date;
  to: Date;
}

export function calculatePeriod(period: string, includeTime: boolean = false): DateRange | null {
  const now = new Date();
  const todayUTC = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
  let from: Date;
  let to: Date;

  switch (period) {
    case 'today':
      from = new Date(todayUTC);
      to = new Date(todayUTC);
      break;

    case 'yesterday':
      from = new Date(todayUTC);
      from.setUTCDate(from.getUTCDate() - 1);
      to = new Date(from);
      break;

    case 'this-week':
      from = new Date(todayUTC);
      const dayOfWeek = from.getUTCDay();
      const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      from.setUTCDate(from.getUTCDate() + diff);
      to = new Date(from);
      to.setUTCDate(to.getUTCDate() + 6);
      break;

    case 'last-week':
      from = new Date(todayUTC);
      const lastWeekDay = from.getUTCDay();
      const lastWeekDiff = lastWeekDay === 0 ? -6 : 1 - lastWeekDay;
      from.setUTCDate(from.getUTCDate() + lastWeekDiff - 7);
      to = new Date(from);
      to.setUTCDate(to.getUTCDate() + 6);
      break;

    case 'this-month':
      from = new Date(Date.UTC(todayUTC.getUTCFullYear(), todayUTC.getUTCMonth(), 1));
      to = new Date(Date.UTC(todayUTC.getUTCFullYear(), todayUTC.getUTCMonth() + 1, 0));
      break;

    case 'last-month':
      from = new Date(
        Date.UTC(todayUTC.getUTCFullYear(), todayUTC.getUTCMonth() - 1, 1)
      );
      to = new Date(Date.UTC(todayUTC.getUTCFullYear(), todayUTC.getUTCMonth(), 0));
      break;

    case 'this-year':
      from = new Date(Date.UTC(todayUTC.getUTCFullYear(), 0, 1));
      to = new Date(Date.UTC(todayUTC.getUTCFullYear(), 11, 31));
      break;

    case 'last-year':
      from = new Date(Date.UTC(todayUTC.getUTCFullYear() - 1, 0, 1));
      to = new Date(Date.UTC(todayUTC.getUTCFullYear() - 1, 11, 31));
      break;

    default:
      return null;
  }

  if (includeTime) {
    to.setUTCHours(23, 59, 59, 999);
  }

  return {
    from: new Date(
      Date.UTC(from.getUTCFullYear(), from.getUTCMonth(), from.getUTCDate(), 12, 0, 0)
    ),
    to: new Date(
      Date.UTC(to.getUTCFullYear(), to.getUTCMonth(), to.getUTCDate(), 12, 0, 0)
    ),
  };
}

export function formatDateForDisplay(date: Date | string): string {
  if (!date) return '';

  try {
    const parsedDate = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(parsedDate.getTime())) {
      return String(date);
    }
    
    return parsedDate.toLocaleDateString('es-ES');
  } catch {
    return String(date);
  }
}

export function formatDateForInput(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDateTimeForInput(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function parseDateInput(value: string): Date | undefined {
  if (!value) return undefined;
  const date = new Date(value + 'T12:00:00Z');
  return isNaN(date.getTime()) ? undefined : date;
}

export function parseDateTimeInput(value: string): Date | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return isNaN(date.getTime()) ? undefined : date;
}
